import styles from './footer.module.css';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';

export function Footer() {

  const [email, setEmail] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(true);

  const handleEmailChange = (e) => {
    const inputEmail = e.target.value;
    setEmail(e.target.value);

    // Проверка валидности email с помощью регулярного выражения
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    setIsValidEmail(emailRegex.test(inputEmail));
  };

  const handleSubscribeClick = () => {
    if (isValidEmail) {
      alert(`You subscribed with email: ${email}`);
      setEmail(''); // Очищаем поле ввода
    } else {
      alert('Invalid email. Please enter a valid email address.');
    }
  };

  return (
    <div className={styles.footer}>
      <div className="container">
        <div className={styles.wrapper}>

          <div className={styles.logotype}>
            <NavLink to="/">
              <svg xmlns="http://www.w3.org/2000/svg" width="110" height="23" viewBox="0 0 110 23" fill="none">
                <g>
                  <path d="M109.805 17.0152V19.7374H107.521C105.085 19.6608 103.783 18.345 103.783 15.8735V9.65636H102.188V7.26839H103.783V4.59497H107.152V7.24054H109.728V9.62155H107.152V15.5393C107.152 16.3399 107.313 16.9804 108.545 16.9804L109.805 17.0152Z" fill="white" />
                  <path d="M88.7587 13.5272V13.3462C88.7223 12.5455 88.8442 11.7454 89.1176 10.9919C89.3909 10.2384 89.8103 9.54621 90.3516 8.95507C90.8929 8.36393 91.5456 7.88543 92.2722 7.54701C92.9989 7.20859 93.7851 7.01689 94.586 6.98291C94.7461 6.98291 94.9132 6.98291 95.0733 6.98291C98.2549 6.98291 101.047 8.83481 101.047 13.2487V14.1886H92.2049C92.2955 16.2215 93.3954 17.3703 95.2473 17.3703C96.8417 17.3703 97.5866 16.674 97.8024 15.6576H100.984C100.594 18.3101 98.4777 19.7861 95.129 19.7861C91.453 19.7582 88.7587 17.4329 88.7587 13.5272ZM97.7328 12.0582C97.6144 10.2063 96.6815 9.31519 95.0594 9.31519C93.4372 9.31519 92.5043 10.3177 92.2746 12.0582H97.7328Z" fill="white" />
                  <path d="M75.0019 13.5272V13.3462C74.9655 12.5466 75.0869 11.7476 75.3594 10.995C75.6319 10.2423 76.05 9.55078 76.5899 8.95982C77.1297 8.36886 77.7808 7.89009 78.5058 7.55088C79.2308 7.21167 80.0156 7.01867 80.8152 6.98291C80.9754 6.98291 81.1424 6.98291 81.3026 6.98291C84.4842 6.98291 87.2829 8.83481 87.2829 13.2487V14.1886H78.4481C78.5386 16.2215 79.6386 17.3703 81.4905 17.3703C83.0848 17.3703 83.8298 16.674 84.0456 15.6576H87.2272C86.8304 18.3101 84.714 19.7861 81.3652 19.7861C77.6962 19.7582 75.0019 17.4329 75.0019 13.5272ZM83.976 12.0582C83.8576 10.2063 82.9247 9.31519 81.3026 9.31519C79.6804 9.31519 78.7753 10.3456 78.5178 12.0513L83.976 12.0582Z" fill="white" />
                  <path d="M55.6963 7.24048H59.2608L61.44 15.4974L63.8279 7.24048H66.6127L68.771 15.4974L71.0684 7.24048H74.3336L70.4627 19.5076H67.121L65.0324 11.8076L62.7976 19.5076H59.414L55.6963 7.24048Z" fill="white" />
                  <path d="M44.3691 15.6506H47.5508C47.697 16.7576 48.247 17.3912 49.709 17.3912C51.0179 17.3912 51.6236 16.8969 51.6236 16.0544C51.6236 15.212 50.9274 14.857 49.1451 14.6063C45.8799 14.112 44.6198 13.1722 44.6198 10.7772C44.6198 8.22217 46.959 6.95508 49.4932 6.95508C52.2153 6.95508 54.2691 7.94369 54.5616 10.7633H51.4217C51.4016 10.5453 51.3386 10.3335 51.2362 10.14C51.1338 9.94652 50.9941 9.77525 50.8252 9.63607C50.6562 9.49689 50.4614 9.39257 50.2519 9.32913C50.0424 9.2657 49.8224 9.2444 49.6046 9.26647H49.5002C48.4002 9.26647 47.7596 9.78166 47.7596 10.5336C47.7596 11.2855 48.3514 11.6127 50.1476 11.8703C53.197 12.3298 54.9027 13.1025 54.9027 15.7272C54.9027 18.3519 52.9742 19.7582 49.7438 19.7582C46.5134 19.7582 44.4596 18.3032 44.3691 15.6506Z" fill="white" />
                  <path d="M30.8486 7.24047H34.2183V9.18288C34.5981 8.46992 35.1746 7.88099 35.8792 7.48607C36.5839 7.09114 37.3872 6.90683 38.1936 6.95503C40.5815 6.95503 42.3151 8.41009 42.3151 11.731V19.5354H38.9872V12.2183C38.9872 10.5544 38.3398 9.76072 36.836 9.76072C36.5181 9.73305 36.198 9.76843 35.8938 9.86482C35.5897 9.96122 35.3076 10.1167 35.0637 10.3224C34.8198 10.5281 34.619 10.78 34.4727 11.0635C34.3264 11.3471 34.2376 11.6567 34.2113 11.9746C34.1939 12.1227 34.1939 12.2722 34.2113 12.4202V19.5076H30.8486V7.24047Z" fill="white" />
                  <path d="M24.3463 4.15632C24.3341 3.82035 24.4219 3.48832 24.5985 3.20225C24.7751 2.91619 25.0326 2.68896 25.3384 2.54933C25.6442 2.4097 25.9846 2.36395 26.3164 2.41787C26.6483 2.47179 26.9566 2.62297 27.2025 2.85225C27.4484 3.08153 27.6207 3.37861 27.6976 3.70588C27.7745 4.03314 27.7526 4.37588 27.6347 4.69069C27.5167 5.0055 27.308 5.27822 27.0349 5.47434C26.7619 5.67046 26.4368 5.78115 26.1008 5.79239H26.0381C25.8296 5.80559 25.6205 5.77749 25.4228 5.70969C25.2252 5.6419 25.0428 5.53574 24.8863 5.39732C24.7298 5.2589 24.6021 5.09094 24.5107 4.90306C24.4192 4.71519 24.3657 4.51111 24.3533 4.30252C24.3475 4.25401 24.3452 4.20515 24.3463 4.15632ZM24.3463 7.24049H27.7508V19.5076H24.3603L24.3463 7.24049Z" fill="white" />
                  <path d="M11.5151 2.74304H22.2784V5.71583H15.3164V10.1506H20.8303V13.012H15.3094V19.5076H11.5151V2.74304Z" fill="white" />
                  <path d="M5.01962 8.22911C5.01962 9.28038 5.01962 10.5614 3.57152 11.0835C5.05443 11.5918 5.01962 12.6709 5.01962 13.7987V17.976C5.01962 18.7696 5.33987 19.25 5.91076 19.3684C6.0362 19.4107 6.16836 19.4296 6.30063 19.4241H7.69304V22.2089H5.39557C2.94494 22.2089 1.5943 20.8165 1.5943 18.2335V13.2905C1.57692 13.0367 1.46503 12.7987 1.28071 12.6234C1.0964 12.4481 0.853055 12.3483 0.598734 12.3437H0V9.9H0.598734C0.85813 9.89658 1.10625 9.79342 1.29162 9.61194C1.47699 9.43046 1.58538 9.18458 1.5943 8.92532V3.91266C1.5943 1.37152 2.91709 0 5.39557 0H7.71393V2.74304H6.32152C6.18909 2.74342 6.05753 2.76456 5.93165 2.8057C5.36076 2.9519 5.04051 3.42532 5.04051 4.1981L5.01962 8.22911Z" fill="white" />
                </g>
                <defs>
                  <clipPath id="clip0_1108_750">
                    <rect width="110" height="22.2785" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </NavLink>
          </div>

          <nav className={styles.navBar}>

            <ul>
              <li>Our team</li>
              <li><NavLink to="/about-us">About us</NavLink></li>
              <li><NavLink to="/about-us#our-team">Team</NavLink></li>
              <li><NavLink to="/what-we-do">What we do</NavLink></li>
              <li><NavLink to="/contact">Contact</NavLink></li>
            </ul>

            <ul>
              <li>More</li>
              <li><NavLink to="/project-page">Projects</NavLink></li>
              <li><NavLink to="/event-page">Events</NavLink></li>
              <li><NavLink to="/donation">Donate</NavLink></li>
              <li><NavLink to="/blog-page">Blog</NavLink></li>
            </ul>

            <ul>
              <li>Connect</li>
              <li><a href="https://www.google.com/search?q=Facebook" target="_blank" rel="noreferrer">Facebook</a></li>
              <li><a href="https://www.google.com/search?q=Instagram" target="_blank" rel="noreferrer">Instagram</a></li>
              <li><a href="https://www.google.com/search?q=Twitter" target="_blank" rel="noreferrer">Twitter</a></li>
              <li><a href="https://www.google.com/search?q=LinkedIn" target="_blank" rel="noreferrer">LinkedIn</a></li>
            </ul>

          </nav>

          <form className={styles.formSubscribe} onSubmit={handleSubscribeClick}>
            <p>Subscribe to get latest updates</p>
            <div className="">
              <input
                type="text"
                id="emailSubscribe"
                name="emailSubscribe"
                value={email}
                onChange={handleEmailChange}
                placeholder="Your email"
              />
              <button className='buttonSecondary' type="button" onClick={handleSubscribeClick}>
                Subscribe
              </button>
            </div>
          </form>

        </div>
      </div>
    </div>
  );
}